module.exports = __webpack_public_path__ + "img/1.fa1d5886.webp";